import React, { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IsAuthenticatedContext } from "context/IsAuthenticatedContext";

const OAuthCallback = () => {
  const { setIsAuthenticated } = useContext(IsAuthenticatedContext);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Parse the access token from the URL
    const params = new URLSearchParams(location.search);
    const accessToken = params.get("access_token");

    if (accessToken) {
      // Store the access token in localStorage
      localStorage.setItem("access_token", accessToken);
      setIsAuthenticated(true);
      // Redirect to your main page or another page
      navigate("/home");
    }
  }, [location, navigate]);

  return <div>Redirecting...</div>;
};

export default OAuthCallback;
